import React, { FunctionComponent, useCallback, useMemo } from "react"
import { useHistory, useRouteMatch } from "react-router"
import { Link } from "react-router-dom"
import DotButton from "../../components/Buttons/DotButton"
import { getARTargetRoutes } from "./inspector/routes"

interface iProps {
  title: string
  submitText: string
  submitDeleteText: string
  handleSubmit: () => void
  handleDelete?: () => void
  isLoading?: boolean
}

const ARTargetHeader: FunctionComponent<iProps> = ({
  title,
  submitText,
  submitDeleteText,
  handleSubmit,
  handleDelete,
  isLoading = false,
}) => {
  const history = useHistory()
  const match = useRouteMatch()
  const handleHisoryBack = useCallback((e: React.SyntheticEvent) => {
    e.preventDefault()
    history.goBack()
  }, [])

  const navRoutes = useMemo(
    () =>
      getARTargetRoutes({
        urlPrefix: match.url,
      }),
    [match.url],
  )

  return (
    <div className="inspector-header">
      <div className="inspector-cover-wrap">
        <div className="inspector-cover-overlay">
          <div className="inspector-headline">
            <Link to="#" onClick={handleHisoryBack}>
              <i className="fa fa-chevron-left"></i>
              <span>Back</span>
            </Link>
            {/* <DotButton
          isLoading={isLoading}
          className={`btn-red submit-button`}
          text={submitDeleteText}
          onClick={handleDelete}
          type="button"
        >
          {submitDeleteText}
        </DotButton> */}
            <DotButton
              className="btn-blue submit-button"
              text={submitText}
              isLoading={isLoading}
              onClick={handleSubmit}
            />
          </div>
          <h1 className="inspector-title">{title}</h1>
        </div>
      </div>
      <div className="inspector-navigation">
        <ul>
          {navRoutes.map((n, i) => (
            <li
              key={i}
              className={history.location.pathname === n.route ? "active" : ""}
            >
              <Link to={n.route} replace>
                {n.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default ARTargetHeader
